// extracted by mini-css-extract-plugin
export default {"notebook-create":"NotebookNew_notebook-create__FNgNs"};